import styled from '@emotion/styled';
import {mixinFocus} from 'webapp-lib/styling';

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const StyledAction = styled.button`
  :focus {
    ${mixinFocus}
  }
`;
